import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import FormsyForm from 'formsy-react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Select } from 'components/FormInput.v2/FormInput'

function getClassName (inputClassName, isCompact) {
  const classes = ['filter'].concat(inputClassName || [])
  if (isCompact) classes.push('filter--compact')
  return classes.join(' ')
}
/**
 * @type {React.FunctionComponent} Filter drop down component
 */
function Filter (props) {
  const {
    defaultOption,
    placeholder,
    className,
    isCompact,
    onChange,
    onFocus,
    options,
    label,
    formInputName,
  } = props
  // create and cache option elements
  const selectOptions = options.reduce((acc, o) => {
    if (o && o.has('name') && o.get('name')) {
      const value = o.get('value') || ''
      const name = o.get('name')
      acc.push((
        <option
          key={`${name}-${value}`}
          value={value}
        >{name}
        </option>
      ))
    }
    return acc
  }, [])

  // onFilter
  // converts the value (string) to an option Map
  // so that legacy components work properly
  const onFilter = useCallback((value) => {
    const option = options.find((o) => String(o.get('value') || '') === value)
    const optionJS = (option && option.toJS()) || {}
    if (onChange) onChange(optionJS)
  }, [options])

  if (!defaultOption && options.size < 1) {
    return null
  }

  const value = (defaultOption
    ? defaultOption.get('value')
    : options.getIn([0, 'value'])) || ''

  return (
    <div className={getClassName(className, isCompact)}>
      <FormsyForm>
        <Select
          className="filter__control"
          placeholder={placeholder}
          onChange={onFilter}
          name={formInputName}
          value={value}
          label={label}
          onFocus={onFocus}
        >{selectOptions}
        </Select>
      </FormsyForm>
    </div>
  )
}

Filter.propTypes = {
  options: ImmutablePropTypes.list.isRequired,
  defaultOption: ImmutablePropTypes.map,
  label: PropTypes.string.isRequired,
  labelClassName: PropTypes.array,
  placeholder: PropTypes.string,
  className: PropTypes.array,
  isCompact: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  formInputName: PropTypes.string,
}

Filter.defaultProps = {
  formInputName: 'filter',
}

export default Filter
